export default __webpack_public_path__ + "static/subscriptions-on-a-delta-lake-8dcead2d54ede5f6657db2dd06977957.png";